// extracted by mini-css-extract-plugin
export default {"Success":"Success_Success__V+ndu","Title":"Success_Title__o3JLP","Description":"Success_Description__IaBUC"};